import * as Blockly from "blockly";
import { defineProgramBlocks, installGenerators, workspaceToPython } from "./blocksSetup";

const API = "/api";

// Generate Python from a workspace JSON without rendering it (used to round-trip verify block solutions)
export const generatePythonHeadless = (workspace, inputs = []) => {
  defineProgramBlocks(inputs);
  installGenerators(inputs);
  const ws = new Blockly.Workspace();
  try {
    Blockly.serialization.workspaces.load(workspace, ws);
    return workspaceToPython(ws);
  } finally {
    ws.dispose();
  }
};

// PUT the block solution; the server regrades the Python against the test cases before storing it.
export const saveBlocksSolution = async (questionId, workspace, python, source) => {
  const r = await fetch(`${API}/admin/questions/${questionId}/blocks-solution`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ workspace, python, source }),
  });
  const d = await r.json().catch(() => ({}));
  if (r.ok) return { status: "verified", question: d.question };
  const detail = d.detail;
  const reason = typeof detail === "string" ? detail : detail?.message || "Could not save the block solution";
  return { status: r.status === 422 ? "failed" : "error", reason, results: detail?.results };
};

// Auto-convert the Python sample solution -> blocks -> Python again -> verify -> save.
export const convertAndVerify = async (question) => {
  const r = await fetch(`${API}/admin/questions/${question.question_id}/blocks-solution/auto`, { method: "POST", credentials: "include" });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) return { status: "unsupported", reason: typeof d.detail === "string" ? d.detail : "Could not convert this solution" };
  let python;
  try {
    python = generatePythonHeadless(d.workspace, question.blocks?.inputs || []);
  } catch (e) {
    return { status: "unsupported", reason: `Blocks could not be loaded: ${e.message}` };
  }
  return saveBlocksSolution(question.question_id, d.workspace, python, "auto");
};

export const solutionStatus = (question) => {
  const b = question?.blocks || {};
  if (b.solution_verified && b.solution_workspace) return { state: "verified", source: b.solution_source || "manual" };
  return { state: "missing", note: b.solution_note || "" };
};
